
































import Vue from 'vue';
import _ from 'lodash';
import {
  SettingData
} from '../types/setting';

declare var _hmt: any;

export default Vue.extend({
  name: 'Setting',
  data(): SettingData {
    return {
      dbsList: [],
      checkdbidList: [],
      checkdbidListOwn: [],
      dbsListOwn: [],
      CheckSelfDBName: ''
    };
  },
  computed: {

  },
  methods: {
    // 设置比对库
    submit() {
      // 事件追踪start
      _hmt.push(['_trackEvent', '设置', '保存', '事件价值', 1]);
      if(this.checkdbidList.length === 0) {
        this.$message({
          message: `请至少选择一个库！`,
          type: 'error'
        });
        return;
      }
      // end
      this.$http.post('/api/Setting/SaveCheckDBSet', {
        checkDBIds: this.checkdbidList
      }).then((data: any) => {
        this.$message({
          message: `设置成功`,
          type: 'success'
        });
        // this.getUserCheckDB();
      });
    },
    // 获取用户设置的比对库
    getCheckDB() {
    //   this.$http.get('/api/Setting/GetUserCheckDB').then((data: any) => {
    //     this.dbsList = data.data;
    //     _.forEach(this.dbsList, (item: any) => {
    //       if (item.status) {
    //         this.checkdbidList.push(item.checkDBId);
    //       }
    //     });
    //   });
      this.$http.get('/api/Setting/GetUserCheckDB?isSetting=1').then((data: any) => {
        let selfDB = data.data.selfDB,
          selfStatus = data.data.selfDBIsChecked,
          selfObj:object={};
        this.dbsList = data.data.wfdbIds;
        if(!!selfDB){
          selfObj = {
            checkDBId : selfDB.checkSelfDBId,
            checkDBName : selfDB.checkSelfDBName,
            status : selfStatus
          };
          this.dbsList.push(selfObj);
        }
        _.forEach(this.dbsList, (item: any) => {
          if (item.status) {
            this.checkdbidList.push(item.checkDBId);
          }
        });
      });
    },
    GetSelfDBStatus() {
      this.$http.get('/api/Setting/GetCheckDBIndexInfo').then((data: any) => {
          this.CheckSelfDBName = data.data.dbStatus
      });
    }
  },
  mounted() {
    this.getCheckDB();
    this.GetSelfDBStatus();
  }
});
